import { Box, Button as PolarisButton, Header, PropertyFilter, Table } from '@amzn/awsui-components-react-v3';
import { Button } from 'AWS-UI-Components-React';
import React, { useMemo } from 'react';
import { useCollection } from '@amzn/awsui-collection-hooks';
import '../../../styles/spotcp.css';
import { downloadFile, toDownloadFormat } from '../../../utilities';
import { EmptyMessage } from '../../content/empty_message';
import { EmptyState } from '../components/common/EmptyState';
import { OPERATION_STATUS } from '../common/constants';
import { BoldEntries } from './flcp_utils';
import {
  buildFilteringProperties,
  buildFilteringOptions,
  getPropertyFilterI18nStrings,
} from '../../common/property_filter_helpers';

const columnDefinitions = [
  {
    id: "component",
    header: "Component",
    cell: e => {
      const fontWeight = BoldEntries.includes(e.component ) ? 'bold' : 'normal';
      return (
        <Box textAlign="left" fontWeight={fontWeight}>
          {e.component}
        </Box>
      );
    }
  },
  {
    id: "absVariancePerUnit",
    header: "Abs Variance Per Unit",
    cell: (e) => {
      const fontWeight = BoldEntries.includes(e.component ) ? 'bold' : 'normal';
      return (
        <Box textAlign="left" fontWeight={fontWeight}>
          {Math.round(e.absVariancePerUnit * 10000) / 10000 || '-'}
        </Box>);
    },
  }
];
const title = "FLCP Accuracy Summary";
const description = "FLCP Abs Variance Per Unit by Component";

/** Download (in the class below) exports the full `items`, not this view's filtered rows. */
const FlcpSummaryTableView = ({ items, loading }) => {
  const filteringProperties = useMemo(() => buildFilteringProperties(columnDefinitions), []);
  const filteringOptions = useMemo(
    () => buildFilteringOptions(items || [], filteringProperties),
    [items, filteringProperties]
  );

  const {
    items: filteredItems,
    actions,
    filteredItemsCount,
    collectionProps,
    propertyFilterProps,
  } = useCollection(items || [], {
    propertyFiltering: {
      filteringProperties,
      noMatch: (
        <EmptyState
          title="No matches"
          subtitle="We can’t find a match."
          action={
            <PolarisButton onClick={() => actions.setPropertyFiltering({ tokens: [], operation: 'and' })}>
              Clear filter
            </PolarisButton>
          }
        />
      ),
    },
    sorting: {}, // use default so pass empty object
  });

  return (
    <Table
      {...collectionProps}
      className="ZebraStripesTable accuracy-table-container"
      columnDefinitions={columnDefinitions}
      items={filteredItems}
      loading={loading}
      resizableColumns
      loadingText="Loading Data..."
      filter={
        <PropertyFilter
          {...propertyFilterProps}
          filteringProperties={filteringProperties}
          filteringOptions={filteringOptions}
          i18nStrings={getPropertyFilterI18nStrings()}
          countText={`${filteredItemsCount} matches`}
          expandToViewport
        />
      }
      header={
        <Header variant="h2" description={description}>
          {title}
        </Header>
      }
      empty={<EmptyMessage />}
    />
  );
};

export class FLCPSAccuracySummaryTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadStatus: OPERATION_STATUS.NONE,
    };
  };

  onDownloadData = () => {
    this.setState({downloadStatus: OPERATION_STATUS.IN_PROGRESS});
    const data = toDownloadFormat(columnDefinitions, this.props.items);
    downloadFile(data, `FLCP_Accuracy_Summary_${this.props.payload.timeFrame}.xls`);
    this.setState({downloadStatus: OPERATION_STATUS.SUCESS});
  }

  render() {
    const {items, loading} = this.props;
    const empty = !items || !items.length;

    return (
      <React.Fragment>
        <div className="awsui-util-action-stripe">
          <div className="awsui-util-action-stripe-title" />
          <div className="awsui-util-action-stripe-group">
            <Button
              text="Download"
              variant="normal"
              onClick={ this.onDownloadData }
              disabled={ loading || empty }
              loading={ this.state.downloadStatus === OPERATION_STATUS.IN_PROGRESS }
            />
          </div>
        </div>
        <br/>
        <FlcpSummaryTableView items={items} loading={loading} />
      </React.Fragment>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/reports/flcp/flcp_accuracy_summary_table.jsx